import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useTranslate } from "@/i18n";

/**
 * Discreet producer opt-in section, placed far down the page.
 * Must NOT compete visually with the main consumer CTA.
 */
const LandingProducerCta = () => {
  const t = useTranslate();
  return (
    <section className="py-10 md:py-14">
      <div className="container max-w-md mx-auto text-center">
        <p className="text-sm text-muted-foreground leading-relaxed">
          {t("home.producerCta.bodyLine1")}
          <br />
          {t("home.producerCta.bodyLine2")}
        </p>
        <Link
          to="/for-producers"
          className="mt-3 inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground transition-colors group"
        >
          {t("home.producerCta.cta")}
          <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
        </Link>
      </div>
    </section>
  );
};

export default LandingProducerCta;
